<template>
  <Page>
    <v-container id="1on1" class="pt-6 pb-3 py-md-12 pt-lg-3 container-md">
      <h1
        v-html="$options.filters?.markdown($jms('1on1.title'))"
        v-show-timeout="[0, 'slide-y']"
        class="text-h4 text-md-h3 mb-3 mb-md-6"
      ></h1>

      <v-row>
        <v-col v-if="$jms('1on1.video')" cols="12" md="4" v-show-timeout="[100, 'slide-x']" class="px-0 px-md-3">
          <Sticky v-model="$vuetify.breakpoint.mdAndUp">
            <v-card :tile="$vuetify.breakpoint.smAndDown" color="background">
              <VideoPlayer
                :aspect-ratio="9/16"
                :src="$jmsPath($jms('1on1.video'))"
                controls
              />
            </v-card>
          </Sticky>
        </v-col>
        <v-col cols="12" md="8" class="pl-md-6" v-show-timeout="[100, 'slide-x-reverse']">
          <div v-html="$options.filters?.markdown($jms('1on1.body'))"></div>
          <v-btn
            :to="{ name: 'contact' }"
            color="primary"
            block
            x-large
            class="mt-4"
          >
            {{ $jms('1on1.cta') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </Page>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Sticky from '@/components/Sticky.vue';
import Page from '@/components/Page.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'

@Component({
  components: {
    Sticky,
    Page,
    VideoPlayer,
  }
})
export default class OneOnOneView extends Vue {

}
</script>

<style lang="scss" scoped>
video {
  cursor: pointer;
}
</style>
